<template>
  <el-row>
    <el-col :span="4">
      <el-form-item>
        <el-select v-model="productiveThing" @change="changeProductiveThing"  filterable clearable placeholder="物件番号">
          <el-option v-for="item in productiveThings" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="4">
      <el-form-item>
        <el-date-picker v-model="productiveYear" :clearable="false" format="YYYY 年" value-format="YYYY" type="year"
                        @change="productiveChangeYear(productiveYear)" placeholder="请选择年份"/>
      </el-form-item>
    </el-col>
    <el-col :span="4">
      <el-form-item>
        <el-date-picker v-model="productiveMonth" format="M 月" value-format="YYYY-M-1" type="month"
                        @change="productiveChangeMonth(productiveMonth)" placeholder="请选择月份"/>
      </el-form-item>
    </el-col>
  </el-row>

  <!-- 生产性-->
  <div style="margin-top: 30px">
    <div v-loading="jiaGongProductiveOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 350px" id="jiaGongProductiveOutput"/>
  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgjiaGongProductive",
  data() {
    return {
      productiveThing:'',
      productiveThings:[],
      productiveMonth : '',
      productiveYear:this.$common.getCurrentYearByMonth().toString(),
      //物件日生产性
      jiaGongProductiveOutput: {
        title: [
          {
            text: '切断加工生产性',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '0' ,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min:0,
            max:300,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '',
            min:0,
            max:10,
            interval:0.5,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1)
              }
            }
          }
        ],
        series: [
          {
            name: '生产重量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '直接生产性',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '目标生产性',
            color:'#fac858',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '总生产性',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      jiaGongProductiveOutputLoading: false,

    }
  },
  methods:{
    changeProductiveThing() {
      this.getDayProductiveOutput();
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)}
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getWujianNames');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.productiveThings = res.data;
    },
    getCountDays(month) {
      const d = new Date(month)
      const y = this.productiveYear
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    productiveChangeMonth(month) {
      this.countDayList = [];
      this.getCountDays(month);
      this.getDayProductiveOutput();
    },
    productiveChangeYear() {
      this.getDayProductiveOutput();
    },
    //物件生产性
    async getDayProductiveOutput() {
      this.jiaGongProductiveOutputLoading = true
      if (!this.productiveYear) {
        return this.$message.error("年不能为空");
      }
      let params
      if (!this.productiveMonth) {
        params = {thing:this.productiveThing, month:this.productiveMonth, year:this.productiveYear}
      } else {
        params = {countDayList: this.countDayList, thing:this.productiveThing, month:this.productiveMonth, year:this.productiveYear};
      }
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getJiaGongProductive',params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.jiaGongProductiveOutput.xAxis[0].data = res.data.xAxis
        this.jiaGongProductiveOutput.series[0].data = res.data.weightList
        this.jiaGongProductiveOutput.series[1].data = res.data.directProductivityList
        this.jiaGongProductiveOutput.series[2].data = res.data.productivityList
        this.jiaGongProductiveOutput.series[3].data = res.data.totalProductiveList
        let a = this.$common.getDivisor(Math.max(...res.data.weightList))
        let b = this.$common.getDivisor(Math.max(...res.data.productivityList))
        this.jiaGongProductiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.weightList)/a)*a
        this.jiaGongProductiveOutput.yAxis[0].interval = Math.round(this.jiaGongProductiveOutput.yAxis[0].max/5*100)/100
        this.jiaGongProductiveOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.productivityList)/b)*b
        this.jiaGongProductiveOutput.yAxis[1].interval = Math.round(this.jiaGongProductiveOutput.yAxis[1].max/5*0.5)/0.5
      }
      this.renderEcharts('jiaGongProductiveOutput',this.jiaGongProductiveOutput)

      this.jiaGongProductiveOutputLoading = false
    },
    selectAllEcharts(){
      this.getDayProductiveOutput()
    },
  },
  mounted() {
    this.selectAllEcharts()
  },
  created() {
    this.getWuJianInFo()

  }
}
</script>

<style scoped>

</style>